export enum ActionTypes {
    ADD_ZONE_TO_BLOCK_BODY = "ADD_ZONE_TO_BLOCK_BODY",
    APPLY_STYLES_TO_ALL_ZONES = "APPLY_STYLES_TO_ALL_ZONES",
    UPDATE_CHILDREN = "UPDATE_CHILDREN",
    REMOVE_ZONE = "REMOVE_ZONE",
    CLEAR = "CLEAR",
}
